import HighchartsComponentBase from "./common/HighchartsComponentBase.js";
import * as utils from "./misc/utils.js";
import {createYears, createRCCAndRegions, createTreatmentList} from './common/DropdownHelper.js';


const template = `
<style>
.optionGroup {
  font-weight: bold;
}

.optionChild {
  padding-left: 15px;
}
.skr-select {
  height:35px; 
  border:1px solid #ddd; 
  padding-left: 6px;
  font-weight: 300;
  padding: .375rem .75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: .25rem;
  transition: border-color .15s;
  margin-right: 8px;
  margin-top: 8px;
}
#highchartsContainer .highcharts-color-11 {
  fill: #005092;
  stroke: #005092;
}
#highchartsContainer .highcharts-color-10 {
  fill: #ffb117;
  stroke: #ffb117;
}
#highchartsContainer .highcharts-color-12 {
  fill: #cccccc;
  stroke: #cccccc;
}
</style>

<div class="instructionsContainer">Välj period, region och behandling</div>
<div id="guiChoices">
<span>
  <span id='yearselector'></span>
  <span id='regionselector'></span>
  <span id='treatmentselector'></span>
</span></div>
`;

class SVFMaxLeadtimePerSVF extends HighchartsComponentBase {
  constructor() {
    super(template);
    this.chartData = {
      chart: {
        type: 'bar'
      },
      title: {
        text: null,
        align: 'left'
      },
      accessibility: {
        description: "Diagram som visar andel patienter som har genomgått ett SVF inom angiven ledtid uppdelat per SVF"
      },
      subtitle: {
        align: 'left',
        useHTML: true
      },
      loading: {
        hideDuration: 1000,
        showDuration: 1000
      },
      xAxis: {
        categories: [],
        title: {
          text: null
        }
      },
      yAxis: [{
        min: 0,
        max: 100,
        title: {
          text: '',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        },
        plotLines: [{
          color: 'black',
          dashStyle: 'shortdash',
          value: 80,
          width: 2
        }]
      },
      {
        min: 0,
        max: 100,
        title: {
          text: null
        },
        opposite: true
      }],
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          let text = '<b>' + this.x + '</b> <br>'
          if (this.point['Totalt antal'] == 0) {
            text += 'Data dold p.g.a. färre än 5 patienter i urvalet';
          } else {
            if (this.point['Angiven ledtid'] != undefined) {
              text += "Angiven ledtid: " + this.point['Angiven ledtid'] + ' dagar<br>';
            }
            if (this.point['Angiven ledtid vid utökad utredning'] != undefined) {
              text += "Angiven ledtid vid utökad utredning: " + this.point['Angiven ledtid vid utökad utredning'] + ' dagar<br>';
            }
            if (this.point['Antal inom ledtiden'] == null) {
              this.point['Antal inom ledtiden'] = 0;
            }
            text += 'Andel inom ledtiden: ' + this.y + '% <br>'
            text += "Antal inom ledtiden: " + this.point['Antal inom ledtiden'] + '<br>';
            text += "Totalt antal: " + this.point['Totalt antal'] + '<br>';
          }
          return text;
        }
      },
      lang: {
        loading: "Hämtar data...",
        accessibility: {
          chartContainerLabel: "Diagram. Visar andel patienter som har genomgått ett SVF inom angiven ledtid per SVF",
          chartTypes: {
            barSingle: "Liggande stapeldiagram med {numPoints} {#plural(numPoints, staplar, stapel)}"
          },
          axis: {
            xAxisDescriptionSingular: "Diagrammet har 1 X-axel som består av olika SVF",
            yAxisDescriptionPlural: "Diagrammet har 1 Y-axel som visar andel personer inom angiven ledtid"
          },
          screenReaderSection: {
            beforeRegionLabel: "Början av det interaktiva diagrammet",
            endOfChartMarker: "Slutet av det interaktiva diagrammet"
          }
        },
        contextButtonTitle: 'Diagram-meny',
        downloadJPEG: 'Ladda ned JPEG-bild',
        downloadPDF: 'Ladda ned PDF-dokument',
        downloadPNG: 'Ladda ned PNG-bild',
        downloadSVG: 'Ladda ned SVG-vektorgrafik',
        downloadCSV: 'Ladda ner CSV-fil',
        downloadXLS: 'Laddan ner Excel-fil',
        months: [ 'Januari' , 'Februari' , 'Mars' , 'April' , 'Maj' , 'Juni' , 'Juli' , 'Augusti' , 'September' , 'Oktober' , 'November' , 'December'],
        noData: 'Ingen data att visa',
        numericSymbols: [ 'k' , 'M' , 'G' , 'T' , 'P' , 'E'],
        printChart: 'Skriv ut diagram',
        shortMonths: [ 'Jan' , 'Feb' , 'Mar' , 'Apr' , 'Maj' , 'Jun' , 'Jul' , 'Aug' , 'Sep' , 'Okt' , 'Nov' , 'Dec'],
        thousandsSep: ' ',
        weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag']
      },
      exporting: {
        enabled: true,
        scale: 1,
        sourceHeight: 600,
        sourceWidth: 800,
        buttons: {
          contextButton: {
              align: 'right',
              x: 0,
              y: 20,
              menuItems: ["printChart",
                    "separator",
                    "downloadPNG",
                    "downloadJPEG",
                    "downloadPDF",
                    "downloadSVG",
                    "separator",
                    "downloadCSV",
                    "downloadXLS",
                    "openInCloud"]
          }
        },
        chartOptions: {
          chart: {
            styledMode: true,
          }
        },
        plotOptions: {
          bar: {
            minPointLength: 6
          }
        }
      },
      plotOptions: {
        bar: {
          minPointLength: 6
        }
      }
      
    };
    super.setChartOptions(this.chartData);
    let shadow = super.getShadow();
    createYears(this, shadow.querySelector('#yearselector'), "https://signe.vantetider.se/seam/resource/rest/selectableYears");
    createRCCAndRegions(this, shadow.querySelector('#regionselector'));
    createTreatmentList(this, shadow.querySelector('#treatmentselector'));
  }

  
  loadChartData() {
    let lowResponseWarning = false;
    var options = "?year=" + this.year;
    if (this.treatmentcode != '') {
      options += "&codeId=" + this.treatmentcode;
    }
    if (!this.region) {
      options += "&centreId=" + this.centre;
    } else {
      options += "&regionId=" + this.region;
    }
    utils.loadJSONP(__BACKEND_URL__ + "/seam/resource/rest/homeRegion/within80SVFResult" + options, false).then((data) => {
      if (data.ERROR) {
        return;
      }
      this.chartData.yAxis[0].title.text = data.titles.yAxis;
      var point = [];
      for (var i = 0; i < data.rows.length; i += 1) {
        let infoObj = {}
        for (let j = 3; j < data.columns.length; j += 1) {
          infoObj[data.columns[j].name] = data.rows[i][j];
        }
        infoObj.y = data.rows[i][2];
        if (infoObj.y < 5) {
          lowResponseWarning = true;
        }
        infoObj.svf = data.rows[i][1];
        if (infoObj.svf == 'Samtliga SVF') {
          infoObj.colorIndex = 10;
        } 
        else if (infoObj['Totalt antal'] == 0) {
          infoObj.colorIndex = 12;
        }
        else {
          infoObj.colorIndex = 11;
        }

        this.chartData.xAxis.categories[i] = data.rows[i][1];
        point.push(infoObj);
      }
      super.addSeries(data.rows[0][0], point);
      
      super.render();
      if (lowResponseWarning) {
        super.setSubtitle('Grå stapel indikerar att diagnosen har dold data p.g.a. färre än 5 patienter i urvalet');
      }
    }).catch((error) => {
      super.errorNoData("#chartContainer");

      console.error(error);
    });
    super.showLoading(true);
  }

  static get observedAttributes() {
    return ['year', 'region', 'centre', 'treatmentcode'];
  }

  get year() {
    return this.getAttribute('year');
  }
  set year(value) {
    this.setAttribute('year', value);
  }
  get region() {
    return this.getAttribute('region');
  }
  set region(value) {
    this.setAttribute('region', value);
  }
  get centre() {
    return this.getAttribute('centre');
  }
  set centre(value) {
    this.setAttribute('centre', value);
  }
  get treatmentcode() {
    return this.getAttribute('treatmentcode');
  }
  set treatmentcode(value) {
    this.setAttribute('treatmentcode', value);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'region') {
      return;
    }

    this.loadChartData();
  }
  connectedCallback() {
    this.centre = 'SWE';
    this.treatmentcode = '';
  }

}

customElements.define('svf-max-ledtid-per-svf', SVFMaxLeadtimePerSVF);

